import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';

// Note: This callback page is deprecated when using Firebase SDK
// Firebase SDK handles OAuth callbacks internally
// This page is kept for backward compatibility only
function GoogleCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const errorParam = searchParams.get('error');

      if (errorParam) {
        setError('Authentication was cancelled or failed');
        setTimeout(() => navigate('/login'), 3000);
        return;
      }

      if (!code) {
        setError('No authorization code received');
        setTimeout(() => navigate('/login'), 3000);
        return;
      }

      // When using Firebase SDK, OAuth is handled automatically
      // Just redirect to login where Firebase will complete the auth
      setError('OAuth is now handled by Firebase SDK. Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={2}
    >
      {error ? (
        <>
          <Alert severity="error">{error}</Alert>
          <Typography variant="body2">Redirecting to login...</Typography>
        </>
      ) : (
        <>
          <CircularProgress />
          <Typography variant="h6">Completing Google sign in...</Typography>
        </>
      )}
    </Box>
  );
}

export default GoogleCallback;
